// extracted by mini-css-extract-plugin
module.exports = {"avatar_top_header_container":"UserInfo_avatar_top_header_container__RKsja","name_box":"UserInfo_name_box__20T3z"};